import React, { useState } from 'react';
import AuthHero from '../components/AuthHero';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.starhubcreative.id';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Password tidak cocok'); return; }
    if (password.length < 6) { setError('Password minimal 6 karakter'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal reset password');
    } finally { setLoading(false); }
  };

  return (
    <div className="sh-auth" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'transparent' }}>
      <AuthHero />
      <div className="sh-auth-card" style={{ width: '100%', maxWidth: 400, background: '#FFFFFF', boxShadow: '0 4px 24px rgba(17,24,39,0.06)', border: '1px solid #E5E7EB', borderRadius: 16, padding: 32 }}>
        <img src="/logo-full-v2.png" alt="Starhub Creative" style={{ height: 56, marginBottom: 24 }} />
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#111827', marginBottom: 8 }}>Password Berhasil Direset!</h2>
            <p style={{ color: '#6B7280', fontSize: 14 }}>Redirect ke login dalam 3 detik...</p>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Reset Password</h1>
            <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Masukkan password baru kamu</p>
            {error && <div style={{ background: 'rgba(239,68,68,0.16)', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>{error}</div>}
            {!token ? (
              <div style={{ textAlign: 'center', color: '#ef4444' }}>Link tidak valid. <Link to="/forgot-password" style={{ color: '#FF5722' }}>Minta link baru</Link></div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#6B7280', marginBottom: 6 }}>Password Baru</label>
                  <input type="password" placeholder="Min 6 karakter" value={password} onChange={e => setPassword(e.target.value)} required style={{ fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#6B7280', marginBottom: 6 }}>Konfirmasi Password</label>
                  <input type="password" placeholder="Ulangi password baru" value={confirm} onChange={e => setConfirm(e.target.value)} required style={{ fontSize: 16 }} />
                </div>
                <button type="submit" className="btn btn-gold" style={{ width: '100%', padding: 14, fontSize: 16 }} disabled={loading}>
                  {loading ? 'Menyimpan...' : 'Reset Password'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
